import { render } from "./SystemCheckScreen.vue?vue&type=template&id=f59b346e&scoped=true"
import script from "./SystemCheckScreen.vue?vue&type=script&lang=js"
export * from "./SystemCheckScreen.vue?vue&type=script&lang=js"

import "./SystemCheckScreen.vue?vue&type=style&index=0&id=f59b346e&scoped=true&lang=scss"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f59b346e"]])

export default __exports__